export const ExternalLinks = {
    enterpriseWireless: {
        serviceFees: 'https://www.enterprisewireless.org/service-fees',
        membership: 'https://www.enterprisewireless.org/membership',
        cevoUrl: 'https://cevo.enterprisewireless.org',
        cevoOnlineUrl: 'https://www.enterprisewireless.org/cevo',
        resourcesUrl: 'https://www.enterprisewireless.org/resources',
        support: 'https://www.enterprisewireless.org/eform/submit/contact',
        contactUs: 'https://www.enterprisewireless.org/contact',
        creditApplication:
            'https://www.enterprisewireless.org/forms-library#:~:text=EWA%20Credit%20Policy%20and%20Application',
    },
} as const;
